<template>
  <div class="mediaRecommendationDetail">
    <!-- 标题栏 -->
    <!-- <van-nav-bar :title="goodsChildName" left-arrow @click-left="onClickLeft" /> -->
    <div class="page">
      <div class="kqb-media-video" v-if="fileType == '1'">
        <TimUiMedia ref="mediaDom" mediaType="video" :crruentMediaObj='crruentMediaObj' @nativeControl="onNatiiveControl" @overPlay="onOver" />
      </div>
      <div class="class-info" v-else>
        <div class="mask"></div>
        <img v-lazy="goodsChildImg" />
        <div class="class-name">
          {{goodsChildName}}</div>
        <div class="class-teacher">授课老师：{{goodsLecturerName}}</div>
        <div class="TimUi-audio-control">
          <i class="iconfont fs-24" :class="[crruentMediaObj.isOpen?'icon-media-stop':'icon-media-player']" @click="listenerButtonPlay(crruentMediaObj)"></i>
          <div class="progress-bar disp-flex-between">
            <span v-text="starttime"></span>
            <div class="progress-slider">
              <van-slider v-model="playbackProgress" inactive-color="#9a9a9a" active-color="#fff" @change="dragPlay">
                <div slot="button" class="custom-button"></div>
              </van-slider>
            </div>
            <span v-text="duration"></span>
            <TimUiMedia ref="mediaDom" mediaType="audio" :crruentMediaObj='crruentMediaObj' @nativeControl="onNatiiveControl" @overPlay="onOver" @updateTime="onUpDate" />
          </div>
        </div>
      </div>
      <div class="class-schedule">
        <div class="class-schedule-item">
          <div class="fc-333">
            <span>{{subjectCount}}/{{goodsQuantity}}</span>
            <span>节</span>
          </div>
          <div class="fc-999">更新/总节数</div>
        </div>
        <div class="class-schedule-item">
          <div class="fc-333">
            <span>{{countStudy}}</span>
            <span>人</span>
          </div>
          <div class="fc-999">加入学习</div>
        </div>
      </div>
      <div class="kqb-tab">
        <div class="kqb-tab-item" :class="[current == 0?'active':'']" @click="switchTab" :data-current="0">
          简 介
        </div>
        <div class="kqb-tab-item" :class="[current == 1?'active':'']" @click="switchTab" :data-current="1">
          目 录
        </div>
      </div>
      <div class="kqb-tab-content">
        <div class="kqb-tab-content-item" :class="[current == 0?'active':'']">
          <div class="kqb-article">
            <div class="fc-555">
              <img v-lazy="item" styel="width:100%;" v-for="(item,index) in goodsDetailImgs" :key="index" />
            </div>
          </div>
        </div>
        <div class="kqb-tab-content-item" :class="[current == 1?'active':'']">
          <div class="kqb-media-list">
            <div class="kqb-media-item" :class="[item.isOpen?'bgC-FB2B3F':'']" v-for="(item,index) in mediaLists" :key="index" @click="listenerButtonPlay(item)">
              <div class="kqb-media-inner">
                <div class="kqb-media-title ellipsis">{{item.goodsChildName}}</div>
                <div class="kqb-media-footer fc-888">
                  <span>{{item.goodsChildTime}} | {{item.countStudy}}人学习</span>
                </div>
              </div>
              <div class="kqb-media-right">
                <i class="iconfont icon-media-player" :class="[item.isOpen?'fc-white':'fc-8290A3']" v-if="!item.isOpen"></i>
                <i class="iconfont icon-media-stop" :class="[item.isOpen?'fc-white':'fc-8290A3']" v-else></i>
                <span :class="[item.isOpen?'fc-white':'fc-8290A3']" v-text="item.isOpen?'暂停':'播放'"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="kqb-submit" v-if="false">
        <div class="kqb-submit-left">
          <div class="disp-flex" @click="collection">
            <img src="img/common/icon/icon_collection.png" v-if="!isCollection" />
            <img src="img/common/icon/icon_collection_HL.png" v-else />
            <div>收藏</div>
          </div>
          <div class="disp-flex">
            <img src="img/common/icon/icon_free.png" />
            <div>免费试听</div>
          </div>
        </div>
        <button class="kqb-btn bgC-FB2B3F">1天1元成为会员</button>
      </div>
      <div class="tips-bar" v-if="isNew">
        <p style="font-Size:25px" v-if="appName.length===2">微信搜索小程序{{appName}}</p>
        <p style="font-Size:25px" v-if="appName.length===3">微信搜索小程序{{appName}}</p>
        <p style="font-Size:22px" v-if="appName.length===4">微信搜索小程序{{appName}}</p>
        <p style="font-Size:21px" v-if="appName.length===5">微信搜索小程序{{appName}}</p>
        <p style="font-Size:20px" v-if="appName.length===6">微信搜索小程序{{appName}}</p>
        <p style="font-Size:18px" v-if="appName.length===7">微信搜索小程序{{appName}}</p>
        <p style="font-Size:17px" v-if="appName.length===8">微信搜索小程序{{appName}}</p>
        <p>进入智课联盟，学习更多课程</p>
      </div>
      <!-- modal -->
      <div class="modal" v-show="showModal" @touchmove.prevent>
        <div class="modal-content">
          <div id="captureId">
            <!-- <img src="img/shareImg/1.jpg" /> -->
            <img :src="showImgUrl" @load="toImg" />
            <div class="pos-relative">
              <h6>{{goodsChildName}}</h6>
              <p class="tl">主讲人：{{goodsLecturerName}}</p>
              <p class="tl">扫描二维码，跟我一起学习</p>
              <!-- <img src="img/ewm.png" class="qr-code" alt="" /> -->
              <img :src="EWMUrl" class="qr-code" alt="" />
            </div>
          </div>
          <button class="kqb-btn bgC-fa5151">长按保存图片</button>
          <img class="show-img dImg" :src="dataURL" alt="">
          <i class="iconfont icon-canel2" @click="showModal=false"></i>
        </div>
      </div>
      <div class="modal" v-if="showVIPModal" @touchmove.prevent>
        <div class="BGurl-modal">
          <img src="img/common/modal/img_artword.png" class="artword" />
          <div class="fc-875940">您将享受如下特权</div>
          <div class="nav-bar" style="padding:0;background: transparent;box-shadow: none;">
            <div class="nav-bar-item" data-uri="/pages/index/curriculum_schedule/curriculum_schedule">
              <img src="img/user/vip_privilege/img_01.png" />
              <div>音频畅听</div>
            </div>
            <div class="nav-bar-item" data-uri="/pages/index/curriculum_schedule/curriculum_schedule">
              <img src="img/user/vip_privilege/img_02.png" />
              <div>1天仅需1元</div>
            </div>
            <div class="nav-bar-item" data-uri="/pages/index/curriculum_schedule/curriculum_schedule">
              <img src="img/user/vip_privilege/img_03.png" />
              <div>邀请码激活</div>
            </div>
          </div>
          <button class="kqb-ybtn fc-78482F" @click="commitPay()">
            支付365成为会员
          </button>
          <i class="iconfont icon-canel3" @click="showVIPModal=false"></i>
        </div>
      </div>
      <div class="loading" v-show="showLoading">
        <img src="img/timg.gif" alt="">
      </div>
      <button open-type='share' @click="downImg">
        <img class="share-button" src="img/common/icon/img_share_code.png" />
      </button>
    </div>
  </div>
</template>

<script>
import TimUiMedia from '@/components/TimUiMedia'
import html2canvas from 'html2canvas'
import QRCode from 'qrcode'
export default {
  name: 'mediaRecommendationDetail',
  components: {
    TimUiMedia
  },
  data () {
    return {
      current: 1,
      showModal: false,
      showVIPModal: false,
      isCollection: false,
      isOpen: false,
      isVideo: false,
      isNew: false,
      starttime: '00:00', // 正在播放时长
      duration: '00:00', // 总时长
      playbackProgress: 0, // 播放进度
      goodsChildTime: '',
      mediaLists: [],
      goodsLecturerDesc: '',
      goodsId: '',
      goodsNo: '',
      isOpenVip: '',
      goodsFirstImg: '',
      crruentMediaObj: {}, // 当前要加载的媒体对象
      subjectCount: 0,
      goodsIsVip: '0',
      goodsBriefDesc: '',
      goodsLecturerName: '',
      goodsQuantity: '',
      goodsChildName: '',
      countStudy: '',
      goodsChildImg: '',
      autoplay: false,
      goodsDetailImgs: [],
      fileType: '0',
      firstFlag: true,
      dataURL: '',
      EWMUrl: '',
      testUrl: '',
      showImgUrl: '',
      locationUrl: '',
      appName: '',
      storeId: 'STOREINFO-0LPU232X3NUEFI2AUSM9IJEQN8M1N',
      userId: '',
      showLoading: false,
      isPay: false
    }
  },
  created () {
    const thisObj = this
    let params = thisObj.$route.query
    // console.log('测试信息' + params.test)
    // if (this.$util.getUrlParam('isUser') === '1') {
    //   let countS = this.$util.getUrlParam('cS')
    //   thisObj.goodsId = this.$util.getUrlParam('gId')
    //   thisObj.countStudy = countS
    //   //   thisObj.isNew = true
    //   thisObj.getVediosPlay()
    //   thisObj.getGoodsInfo()
    //   let upId = this.$util.getUrlParam('upId')
    //   let apNam = this.$util.getUrlParam('aN')
    //   window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd5ba93934e0b0e5b&redirect_uri=https://zklm.kequbang.com?isUser=' + apNam + '!' + upId + '!' + thisObj.goodsId + '!' + countS + '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
    // } else
    if (params.isUser === '0') {
      let goodsId = params.goodsId
      let goodsNo = params.goodsNo
      let goodsQuantity = params.goodsQuantity
      let countStudy = params.countStudy
      //   let goodsDetailImgs = JSON.parse(params.goodsDetailImgs)
      let goodsDetailImgs = params.goodsDetailImgs.split(',')
      let goodsIsVip = params.goodsIsVip
      thisObj.goodsId = goodsId
      thisObj.goodsIsVip = goodsIsVip
      thisObj.goodsQuantity = goodsQuantity
      thisObj.countStudy = countStudy
      thisObj.goodsChildName = params.goodsName
      thisObj.goodsNo = goodsNo
      thisObj.goodsDetailImgs = goodsDetailImgs
      thisObj.goodsFirstImg = params.goodsFirstImg
      thisObj.fileType = params.fileType
      thisObj.goodsBriefDesc = params.goodsBriefDesc
      thisObj.goodsLecturerName = params.goodsLecturerName
      thisObj.goodsLecturerDesc = params.goodsLecturerDesc
      thisObj.goodsChildImg = params.goodsFirstImg
      thisObj.storeId = params.storeId
      thisObj.userId = params.userId
      //   thisObj.getAppName()
      //   console.log('当前地址' + window.location.href)192.168.1.100
      //   let locaUrl = window.location.href
      //   thisObj.locationUrl = locaUrl.substring(0, locaUrl.indexOf('?'))
      thisObj.locationUrl = 'https://zklm.kequbang.com/'
      //   thisObj.locationUrl = 'http://192.168.1.100/'
      thisObj.locationUrl += '?isUser=1&upId=' + thisObj.userId + '&gId=' + thisObj.goodsId + '&cS=' + thisObj.countStudy + '&aN=' + thisObj.storeId
      thisObj.getGoodsInfo()
      thisObj.createEWM()
      thisObj.getVediosPlay()
    } else if (params.isUser === '2') {
      var that = this
      //   let paInfo = this.$util.getUrlParam('isUser')
      //   let infos = paInfo.split('!')
      thisObj.isNew = true
      //   thisObj.storeId = infos[0]
      //   let upUserId = infos[1]
      //   that.goodsId = infos[2]
      //   that.countStudy = infos[3]
      thisObj.storeId = params.storeId
      let upUserId = params.upUserId
      thisObj.userId = upUserId
      that.goodsId = params.goodsId
      that.countStudy = params.countStudy
      thisObj.getAppName()
      thisObj.getGoodsInfo()
      //   let usInfos
      //   let value = this.$util.getUrlParam('code')
      //   if (value != null) {
      //     that.$api.post(that.requestUrl + '/weixin/get/person/info', { 'weixinCode': value }).then(res => {
      //       const userInfo = res.resultData
      //       this.$root.userInfo = userInfo
      //       usInfos = userInfo
      //       this.$root.isLogin = true
      //     })
      //   } else {
      //     window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd5ba93934e0b0e5b&redirect_uri=https://zklm.kequbang.com?isUser=' + thisObj.storeId + '!' + upUserId + '!' + that.goodsId + '!' + that.countStudy + '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
      //   }
      //   var wx = require('weixin-js-sdk')
      //   var href = window.location.href
      //   var urlConfig = that.requestUrl + '/weixin/get/js/config?fromDevice=h5'
      //   that.$api.post(urlConfig, { 'url': href }).then(res => {
      //     if (res.resultCode === 200 && res.success) {
      //       wx.config({
      //         debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      //         appId: res.resultData.appid, // 必填，公众号的唯一标识
      //         timestamp: res.resultData.timestamp, // 必填，生成签名的时间戳
      //         nonceStr: res.resultData.noncestr, // 必填，生成签名的随机串
      //         signature: res.resultData.sign, // 必填，签名
      //         jsApiList: ['checkJsApi', 'chooseWXPay'] // 必填，需要使用的JS接口列表/person/login
      //       })
      //     }
      //   })
      //   that.$api.post(that.requestUrl + '/person/login/weixin', {
      //     'storeId': thisObj.storeId,
      //     'wxOpenId': usInfos.personAccountInfoDsfOpenId,
      //     'wxHeadImg': usInfos.personAccountInfoDsfHeadImg,
      //     'wxCity': usInfos.personAccountInfoDsfCity,
      //     'wxCountry': usInfos.personAccountInfoDsfCountry,
      //     'wxNickName': usInfos.personAccountInfoDsfNickName,
      //     'wxProvince': usInfos.personAccountInfoDsfProvince,
      //     'wxPrivilege': '',
      //     'wxSex': usInfos.personAccountInfoSex,
      //     'wxUnionid': usInfos.personAccountInfoDsfUnionid,
      //     'mobileNo': '',
      //     'mobileCode': '',
      //     'personParentId': upUserId
      //   }).then(res => {
      //     const userInfo = res.resultData
      //     this.$root.userInfo = userInfo
      //     this.$root.isLogin = true
      //   })
      //   let locaUrl = window.location.href
      //   thisObj.locationUrl = locaUrl.substring(0, locaUrl.indexOf('?'))
      thisObj.locationUrl = 'https://zklm.kequbang.com/'
      //   thisObj.locationUrl = 'http://192.168.1.100/'
      thisObj.locationUrl += '?isUser=1&upId=' + thisObj.userId + '&gId=' + thisObj.goodsId + '&cS=' + thisObj.countStudy + '&aN=' + thisObj.storeId
      thisObj.createEWM()
      thisObj.getVediosPlay()
    }
  },
  watch: {
    crruentMediaObj: function (n, o) {
      const thisObj = this
      // 判断是否是第一次加载此页面
      if (o.goodsChildId === undefined) {
        thisObj.$refs.mediaDom.onPause()
        return
      }
      if (o.goodsChildId !== n.goodsChildId) {
        thisObj.$refs.mediaDom.onReplay()
      }
    }
  },
  destroyed () {
      if(this.personFootInfo!=null){
        this.leavePersonFoot()
      }
  },
  mounted () {
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    // 目录/简介 tab切换
    switchTab (e) {
      let current = e.currentTarget.dataset.current
      this.current = current
    },
    // 生成图片
    toImg () {
      //   setTimeout(function () {
      // that.toImg()
      html2canvas(document.querySelector('#captureId')).then(canvas => {
        let imgUrl = canvas.toDataURL('image/png')
        let that = this
        that.dataURL = imgUrl
        // eslint-disable-next-line handle-callback-err
      }).catch(error => {
      })
      //   }, 500)
      this.showLoading = false
    },
    // 下载图片
    downImg () {
      let that = this
      let imgNum = Math.floor(Math.random() * (6 - 1)) + 1
      that.showImgUrl = 'img/shareImg/' + imgNum + '.jpg'
      that.showModal = true
      that.showLoading = true
      setTimeout(function () {
        that.toImg()
      }, 2000)
    },
    /**
    * 图片转base64格式
    */
    getBase64Image (img) {
      var that = this
      var canvas = document.createElement('canvas')
      canvas.width = img.width
      canvas.height = img.height
      var ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0, img.width, img.height)
      var ext = img.src.substring(img.src.lastIndexOf('.') + 1).toLowerCase()
      that.testUrl = canvas.toDataURL('image/' + ext)
    },
    // 生成二维码
    createEWM () {
      let canvas = document.createElement('canvas')
      // 用 canvas 对象和邀请链接生成二维码，并将生成的二维码转为 base64
      QRCode.toCanvas(canvas, this.locationUrl, (error) => {
        if (error) {
          //   console.log(error)
        } else {
          this.EWMUrl = canvas.toDataURL('image/jpeg')
        }
      })
    },
    // 根据id获取商品数据
    getGoodsInfo () {
      const thisObj = this
      var param = {}
      param['fromDevice'] = 'h5'
      param['goodsId'] = thisObj.goodsId
      thisObj.$api.get(thisObj.requestUrl + '/knowledge/goods/info/getKnowledgeGoodsById?fromDevice=h5&goodsId=' + this.goodsId, {}).then(res => {
        if (res.success) {
          let goodInfo = res.resultData
          let goodsNo = goodInfo.goodsNo
          let goodsQuantity = goodInfo.goodsQuantity
          let goodsDetailImgs = goodInfo.goodsNativeDetailDesc.split(',')
          let goodsIsVip = goodInfo.goodsIsVip
          thisObj.goodsIsVip = goodsIsVip
          thisObj.goodsQuantity = goodsQuantity
          thisObj.goodsChildName = goodInfo.goodsName
          thisObj.goodsNo = goodsNo
          thisObj.goodsDetailImgs = goodsDetailImgs
          thisObj.goodsFirstImg = goodInfo.goodsFirstImg
          thisObj.fileType = goodInfo.goodsType
          thisObj.goodsBriefDesc = goodInfo.goodsBriefDesc
          thisObj.goodsLecturerName = goodInfo.goodsLecturerName
          thisObj.goodsLecturerDesc = goodInfo.goodsLecturerDesc
          thisObj.goodsChildImg = goodInfo.goodsFirstImg
          thisObj.goodsLongName = goodInfo.goodsLongName
          if (thisObj.$root.userInfo!=null) {
              thisObj.getThirdId()
          }
          //   console.log('当前地址' + window.location.href)
          //   let locaUrl = window.location.href
          //   thisObj.locationUrl = locaUrl.substring(0, locaUrl.indexOf('?'))
          //   thisObj.locationUrl = 'http://zklm.kequbang.com/'
          //   thisObj.locationUrl += '?isUser=1&upUserId=' + thisObj.goodsId + '&goodsId=' + thisObj.goodsId
          //   thisObj.createEWM()
          //   thisObj.getVediosPlay()
        } else {
          thisObj.$util.requetServerError(res.resultMsg)
        }
      })
    },
    // 根据id获取小程序名
    getAppName () {
      const thisObj = this
      thisObj.$api.get(thisObj.requestUrl + '/auth/store/card/bag/store/getAppName?fromDevice=h5&storeId=' + this.storeId, {}).then(res => {
        if (res.success) {
          this.appName = res.resultData.storeName
          //   console.log(this.appName)
        } else {
          thisObj.$util.requetServerError(res.resultMsg)
        }
      })
    },
    // 页面跳转
    pageJumpCate (uri) {
      const thisObj = this
      let queryData = {
      }
      thisObj.$router.push({
        path: uri,
        query: queryData
      })
    },
    // 支付会员费用
    commitPay () {
      var that = this
      var person = this.$root.userInfo
      var isLogin = that.$root.isLogin = true
      if (!isLogin) {
        that.$util.requetServerError('亲,你还没有登录,请先登录')
      } else {
        var wx = require('weixin-js-sdk')
        var href = window.location.href
        var urlConfig = that.requestUrl + '/weixin/get/js/config?fromDevice=h5'
        // var urlConfig = that.requestUrl + '/weixin/get/knowledge/config?fromDevice=h5'
        that.$api.post(urlConfig, { 'url': href, 'storeId': person.storeId }).then(res => {
          if (res.resultCode === 200 && res.success) {
            wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: res.resultData.appid, // 必填，公众号的唯一标识
              timestamp: res.resultData.timestamp, // 必填，生成签名的时间戳
              nonceStr: res.resultData.noncestr, // 必填，生成签名的随机串
              signature: res.resultData.sign, // 必填，签名
              jsApiList: ['checkJsApi', 'chooseWXPay'] // 必填，需要使用的JS接口列表
            })
            var url = that.requestUrl + '/auth/knowledge/vip/official/confirm/pay?fromDevice=h5&personId=' + person.personAccountInfoId + '&storeId=' + person.storeId + '&personToken=' + person.personAccountToken + '&loginTimestamp=' + person.personLoginTimeStamp + '&personOpenId=' + person.personAccountInfoDsfOpenId
            // var url = that.requestUrl + '/auth/knowledge/vip/official/confirm/pay?fromDevice=h5&personId=' + '' + '&storeId=' + 'STOREINFOFBCB01621A0AFE62F036E8C9D0B01ABC' + '&personToken=' + '' + '&loginTimestamp=' + '' + '&personOpenId=' + ''
            that.$api.get(url, {}).then(result => {
              if (result.resultCode === 200 && result.success) {
                wx.chooseWXPay({
                  timestamp: result.resultData.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                  nonceStr: result.resultData.nonceStr, // 支付签名随机串，不长于 32 位
                  package: result.resultData.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                  signType: result.resultData.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                  paySign: result.resultData.sign, // 支付签名
                  success: function (res) {
                    // 支付成功后的回调函数
                    person.isVip = 1
                    this.isVip = 1
                    this.$root.userInfo = person
                    that.$util.showSuccessMsg('开通会员成功')
                  },
                  cancel: function () {
                    alert('支付已取消')
                  },
                  error: function (e) {
                  }
                })
              } else {
                that.$util.requetServerError(res.resultMsg)
              }
            }).catch(function (error) {
              that.$util.requetServerError(error)
            })
          } else {
            that.$util.requetServerError(res.resultMsg)
          }
        })
      }
    },
    // 根据id获取媒体详情数据
    getVediosPlay () {
      const thisObj = this
      thisObj.$api.get(thisObj.requestUrl + '/knowledge/goods/child/getKnowledgeChildInfos?fromDevice=h5&goodsId=' + this.goodsId, {}).then(res => {
        if (res.success) {
          thisObj.selectIsPay()
          if (res.resultData.length > 0) {
            thisObj.subjectCount = res.resultData.length
            // console.log(res)
            for (var i = 0; i < res.resultData.length; i++) {
              res.resultData[i]['isOpen'] = false
              thisObj.mediaLists = res.resultData
              thisObj.src = res.resultData[i].goodsChildFilePath
              thisObj.goodsChildTime = res.resultData[i].goodsChildTime
              thisObj.goodsChildName = res.resultData[0].goodsChildName
              thisObj.goodsChildImg = res.resultData[0].goodsChildImg
            }
            thisObj.crruentMediaObj = res.resultData[0]
            thisObj.duration = thisObj.crruentMediaObj.goodsChildTime
          }
        } else {
          thisObj.$util.requetServerError(res.resultMsg)
        }
      })
    },
    // 根据id获取媒体详情数据
    selectIsPay () {
      const thisObj = this
      var person = this.$root.userInfo
      if (person == null) {
        thisObj.isPay = false
        return
      }
      thisObj.$api.get(thisObj.requestUrl + '/auth/knowledge/get/isPay?fromDevice=h5&goodsId=' +
          this.goodsId + '&personId=' + this.$root.userInfo.personAccountInfoId + '&phone=' +
          person.personMobileNo + '&storeId=' + person.storeId, {}).then(res =>{
        if (res.success) {
          thisObj.isPay = res.resultData
        } else {
          thisObj.$util.requetServerError(res.resultMsg)
        }
      })
    },
    // 播放
    listenerButtonPlay (item) {
      const thisObj = this
      // 深拷贝数据
      var person = this.$root.userInfo
      //   var goodsIsVip = this.goodsIsVip
      var isPay = this.isPay
      let data = JSON.parse(JSON.stringify(thisObj.mediaLists))
      for (let i in data) {
        if (data[i].goodsChildId === item.goodsChildId && person !== null) {
          //   if (i > 0 && goodsIsVip === 1) {
          //     if (person.personIsVip === '0') {
          //       this.showVIPModal = false
          //       return
          //     }
          //     if (person.personIsVip === '' || person === null || person.personIsVip === null) {
          //       return
          //     }
          //   }
          if (i > 0 && !isPay) {
            thisObj.$util.requetServerError('尚未开通，不可播放')
            return
          }
          data[i].isOpen = !data[i].isOpen
          thisObj.crruentMediaObj = data[i]
          thisObj.duration = data[i].goodsChildTime
          thisObj.$refs.mediaDom.startPlayOrPause()
          thisObj.goodsChildName = item.goodsChildName
          thisObj.addPersonLookGoodsInfo(item.goodsChildId)
        } else {
          data[i].isOpen = false
        }
      }
      thisObj.mediaLists = data
    },
    // 拖动设置播放进度
    dragPlay (value) {
      this.$refs.mediaDom.setCrruntTime(value)
    },
    // 通过原生控件控制播放暂停
    onNatiiveControl (id, type) {
      const thisObj = this
      let data = JSON.parse(JSON.stringify(thisObj.mediaLists))
      for (let i in data) {
        if (id === data[i].goodsChildId) {
          if (type === 'play') {
            data[i].isOpen = true
          } else {
            data[i].isOpen = false
          }
        }
      }
      thisObj.mediaLists = data
    },
    // 播放结束后
    onOver (id) {
      const thisObj = this
      let data = JSON.parse(JSON.stringify(thisObj.mediaLists))
      for (let i in data) {
        if (id === data[i].goodsChildId) {
          data[i].isOpen = false
          thisObj.crruentMediaObj.isOpen = false
          thisObj.playbackProgress = 0
        }
      }
      thisObj.mediaLists = data
    },
    // 更新当前播放时间
    onUpDate (time, totalTime) {
      this.playbackProgress = time / totalTime * 100
      this.starttime = this.$util.formatSecondToMinutes(time, 'mm:ss')
    },
    addPersonLookGoodsInfo (childId) {
      const thisObj = this
      var person = this.$root.userInfo
      if (person == null) {
        return
      }
      var personLookGoodsNo = this.goodsNo
      var uri = thisObj.requestUrl + '/person/openApp/log/addPersonLookGoodsLog?fromDevice=h5&personLookGoodsNo=' + personLookGoodsNo + '&personLookGoodsChildId=' + childId + '&personId=' + person.personAccountInfoId + '&personToken=' + person.personAccountToken + '&loginTimestamp=' + person.personLoginTimeStamp + '&personOpenId=' + person.personAccountInfoDsfOpenId
      thisObj.$api.get(uri, {}).then(res => {
        if (res.success) {
          //   console.log('添加信息成功')
        } else {
          //   thisObj.$util.requetServerError(res.resultMsg)
        }
      }).catch(function (error) {
        // thisObj.$util.requetServerError(error)
      })
    },
    getThirdId () {
      const thisObj = this
      var person = this.$root.userInfo
      var personLookGoodsNo = this.goodsNo
      var uri = thisObj.requestUrl + '/auth/person/info/third/radio?fromDevice=h5&allianceStoreId='
       + person.storeId + '&phone=' + person.personMobileNo
      thisObj.$api.get(uri, {}).then(res => {
        if (res.success) {
          let info = res.resultData
          thisObj.userThirdId = info.thirdId
          thisObj.addPersonFoot()
        } else {
          //   thisObj.$util.requetServerError(res.resultMsg)
        }
      }).catch(function (error) {
        // thisObj.$util.requetServerError(error)
      })
    },
    addPersonFoot () {
      const thisObj = this
      var person = this.$root.userInfo
      if (person == null) {
        return
      }
      var personLookGoodsNo = this.goodsNo
      var uri = thisObj.requestUrl + '/person/foot/add?fromDevice=h5&'
      var params = {
        'storeId': person.storeId,
        'type': 3,
        'explain': thisObj.goodsLongName,
        'personId': person.personAccountInfoId,
        'personThirdId': thisObj.userThirdId,
        'personName': person.personNickName,
        'personImg': person.personHeadImg
      }
      thisObj.$api.post(uri, params).then(res => {
        if (res.success) {
          thisObj.personFootInfo = res.resultData
        } else {
          //   thisObj.$util.requetServerError(res.resultMsg)
        }
      }).catch(function (error) {
        // thisObj.$util.requetServerError(error)
      })
    },
    leavePersonFoot () {
      const thisObj = this
      var uri = thisObj.requestUrl + '/person/foot/update?fromDevice=h5&footId=' + thisObj.personFootInfo.footId +
      '&startTime=' + thisObj.personFootInfo.startTime
      var params = {
        'footId': thisObj.personFootInfo.footId,
        'startTime': thisObj.personFootInfo.startTime
      }
      thisObj.$api.post(uri, params).then(res => {
        if (res.success) {
          thisObj.personFootInfo = null
        } else {
          //   thisObj.$util.requetServerError(res.resultMsg)
        }
      }).catch(function (error) {
        // thisObj.$util.requetServerError(error)
      })
    },
    // 收藏
    collection () {
      this.isCollection = !this.isCollection
    }
  }
}
</script>
<style scoped>
.TimUi-audio-control {
  z-index: 20;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  height: 90px;
  padding: 0 35px;
  background: rgba(0, 0, 0, 0.6);
}
.TimUi-audio-control .TimUi-media {
  visibility: hidden;
}
.TimUi-audio-control .iconfont.fs-24 {
  margin: 0 4% 0 0;
  font-size: 24px;
  color: #fff;
}
.TimUi-audio-control .progress-bar {
  width: 100%;
  color: #fff;
}
.TimUi-audio-control .progress-bar .progress-slider {
  width: 92%;
  margin: 0 4%;
  padding: 12px 0 0 0;
}
.TimUi-audio-control .progress-bar .van-slider {
  width: 100%;
}
.custom-button {
  width: 20px;
  height: 20px;
  background: #fff;
  border-radius: 200px;
}
.mask {
  z-index: 8;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
}

.class-info {
  position: relative;
  width: 100%;
  height: 422px;
}
.class-info .TimUi-media {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 99;
}

.share-button {
  position: fixed;
  bottom: 300px;
  right: 30px;
  width: 70px;
  height: 70px;
  border-radius: 50%;
}

.class-info img {
  z-index: 1;
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  max-width: 100%;
  height: 100%;
}

.class-info .class-name,
.class-info .class-teacher {
  z-index: 10;
  position: absolute;
  bottom: 34px;
  left: 38px;
}

.class-info .class-name {
  bottom: 80px;
  font-size: 42px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
}

.dImg {
  opacity: 0;
  position: absolute;
  top: 580px;
  right: 0px;
}

.class-info .class-teacher {
  font-size: 30px;
  font-family: MicrosoftYaHeiLight;
  font-weight: 300;
  color: rgba(255, 255, 255, 1);
}

.class-schedule {
  display: flex;
  width: 100%;
  height: 140px;
  background: rgba(248, 248, 248, 1);
}

.class-schedule-item {
  position: relative;
  text-align: center;
  width: 50%;
  padding: 30px 0 0 0;
  box-sizing: border-box;
}

.class-schedule-item:after {
  content: "";
  position: absolute;
  top: 30px;
  left: 0;
  bottom: 0;
  border: none;
  border-right: 1px solid rgba(153, 153, 153, 1);
  transform: scaleY(0.6);
  transform-origin: 0 0;
}

.class-schedule-item:first-child:after {
  border: 0;
}

.class-schedule-item .fc-999 {
  font-size: 26px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
}

.class-schedule-item span {
  font-size: 32px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}

.class-schedule-item text:first-child {
  font-size: 38px;
}

.kqb-article-title {
  margin: 43px 0 32px 0;
  font-size: 38px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}

.kqb-article div.fc-555 {
  line-height: 18px;
  font-size: 28px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(85, 85, 85, 1);
}

.line {
  width: 100%;
  height: 20px;
  margin: 83px 0 0 0;
  background: rgba(248, 248, 248, 1);
}

.class-schedule-item {
  position: relative;
}

.kqb-tab {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 0px 0 0 0;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 5px 0px rgba(117, 117, 117, 0.17);
}

.kqb-tab-item {
  height: 100px;
  line-height: 100px;
  font-size: 30px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(143, 143, 143, 1);
}

.kqb-tab-item.active {
  color: rgba(51, 51, 51, 1);
}

.kqb-tab-item.active:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 68px;
  height: 6px;
  background: rgba(251, 43, 63, 1);
  transform: translate(-50%, 0);
}

.kqb-tab-content {
  padding: 0 0 140px 0;
}

.kqb-tab-content .kqb-tab-content-item {
  display: none;
}

.kqb-tab-content .kqb-tab-content-item.active {
  display: block;
}

/*媒体列表*/
.kqb-media-list {
  padding: 0 25px;
}

.kqb-media-item {
  /* display: block; */
  margin: 25px 0 0 0;
  padding: 35px 17px 35px 30px;
  background: rgba(243, 245, 247, 1);
  border-radius: 5px;
}

.kqb-media-item.active {
  background: rgba(251, 43, 63, 1);
}

.kqb-media-inner .kqb-media-title {
  margin: 0 0 17px 0;
}

.kqb-media-inner .kqb-media-footer {
  justify-content: initial;
  font-size: 24px;
}

.kqb-media-right {
  display: flex;
  align-items: center;
  top: 50%;
  right: 17px;
  /* transform: translate(0, -50%); */
  color: transparent;
}

.kqb-media-right .iconfont {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  margin: 0 6px 0 0;
  font-size: 28px;
  border-radius: 200px;
  color: rgba(245, 245, 245, 1);
  background: rgba(130, 144, 143, 1);
}

.kqb-media-right .iconfont.icon-media-player::before {
  margin: 0 0 0 8px;
}

.kqb-media-item.bgC-FB2B3F .kqb-media-right .iconfont {
  color: rgba(251, 43, 63, 1);
  background: rgba(255, 255, 255, 1);
}

.kqb-media-right span {
  white-space: nowrap;
}

.fc-8290A3 {
  color: #8290a3;
}

.bgC-FB2B3F {
  background: #fb2b3f;
}

.kqb-media-item.bgC-FB2B3F .kqb-media-title,
.kqb-media-item.bgC-FB2B3F .kqb-media-footer {
  color: #fff;
}

/*提交*/
.kqb-submit {
  position: fixed !important;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  padding: 0 17px 0 34px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 5px 23px 1px rgba(150, 174, 206, 0.63);
}

.kqb-submit-left {
  display: flex;
  align-items: center;
  font-size: 30px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}

.kqb-submit-left .disp-flex {
  align-items: center;
}

.kqb-submit-left .disp-flex img {
  max-width: 43px;
  width: 43px;
  height: 43px;
  margin: -2px 18px 0 0;
}

.kqb-submit-left .disp-flex:first-child {
  margin: 0 36px 0 0;
}

.kqb-submit-left .disp-flex:first-child div {
  margin: 0 13px 0 0;
}

.kqb-submit-left .disp-flex div {
  line-height: 98px;
  white-space: nowrap;
}

.kqb-submit .kqb-btn.bgC-FB2B3F {
  width: 290px;
  height: 66px;
  line-height: 66px;
  margin: 16px 0;
  padding: 0;
  text-align: center;
  font-size: 30px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  background: rgba(251, 43, 63, 1);
  border: 0;
  border-radius: 33px;
}

.tips-bar {
  position: fixed;
  bottom: 120px;
  left: 1%;
  right: 1%;
  width: 98%;
  height: 178px;
  padding: 34px 0 0 0;
  background: url("~@/assetes/img_tips_bar.png") no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box;
}

.tips-bar p {
  margin: 0;
  padding: 0 0 0 68px;
  font-size: 49px;
  font-family: Adobe Heiti Std;
  font-weight: bold;
  font-style: italic;
  color: rgba(255, 255, 255, 1);
  text-shadow: 0px 2px 2px rgba(128, 45, 32, 0.3);
}
.tips-bar p:last-child {
  margin: 20px 0 0 0;
  font-size: 22px;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  text-shadow: 0px 0px 10px rgba(255, 36, 0, 1);
}
.nav-bar {
  display: flex;
  margin: 43px 0 61px 0;
}

.nav-bar .nav-bar-item {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  text-align: center;
  font-size: 24px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}

.nav-bar .nav-bar-item img {
  max-width: 80px;
  height: 80px;
  margin: 0 auto;
}

.nav-bar .nav-bar-item div {
  padding: 16px 0 0 0;
}

/*modal*/
.modal {
  z-index: 50;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  /* padding: 0 70px; */
  background: rgba(0, 0, 0, 0.7);
}

.modal-content {
  position: absolute;
  top: 50%;
  margin: 0 70px;
  background-color: #fff;
  transform: translate(0, -50%);
}

.modal-content .pos-relative {
  padding: 0 44px 28px 44px;
}

.modal-content .pos-relative:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 44px;
  right: 44px;
  border: none;
  border-bottom: 1px dashed #868686;
  transform: scaleY(0.5);
  transform-origin: 0 0;
}
/* .modal-content img {
  width: 100%;
  height: 520px;
} */

.modal-content h6 {
  margin: 20px 0;
  font-size: 37px;
}

.modal-content p:nth-child(3) {
  margin: 77px 0 0 0;
  font-size: 24px;
  color: #fa5151;
}

.modal-content .qr-code {
  position: absolute;
  right: 44px;
  top: 60px;
  width: 130px;
  height: 130px;
}

.modal .kqb-btn {
  /* position: absolute;
  bottom: 120px;
  left: 50%; */
  width: 506px;
  height: 85px;
  margin: 28px auto;
  border: 0;
  /* background: linear-gradient(
    90deg,
    rgba(219, 178, 146, 1) 0%,
    rgba(248, 223, 196, 1) 100%
  ); */
  /* box-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.5); */
  border-radius: 10px;
  color: #fff;
  /* transform: translate(-50%, 0); */
}

.bgC-fa5151 {
  background-color: #fa5151;
}

.modal .kqb-btn text:first-child {
  font-weight: bold;
}

.modal .icon-canel2 {
  position: absolute;
  top: 20px;
  right: -15px;
  color: rgb(229, 192, 192);
  transform: translate(-50%, 0);
}

.modal .icon-canel3 {
  position: absolute;
  bottom: -80px;
  left: 50%;
  color: #fff;
  margin-left: 30px;
  transform: translate(-50%, 0);
}

.BGurl-modal {
  width: 90%;
  height: 755px;
  margin: 36% 0 0 0;
  padding: 80px 0 0 50px;
  box-sizing: border-box;
}

.BGurl-modal .artword {
  max-width: 418px;
  height: 121px;
  margin: 0 auto;
}

.BGurl-modal .fc-875940 {
  max-width: 418px;
  margin: 26px auto 0 auto;
  font-size: 24px;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  color: rgba(135, 89, 64, 1);
}

.modal .nav-bar {
  width: 80%;
  margin: 43px auto 61px auto;
}

.modal .nav-bar .nav-bar-item {
  font-size: 26px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(120, 72, 47, 1);
}

.modal .nav-bar .nav-bar-item img {
  max-width: 70px;
  height: 70px;
}

.modal .kqb-ybtn {
  position: absolute;
  bottom: 120px;
  left: 50%;
  width: 506px;
  height: 85px;
  margin: 0 auto;
  margin-left: 30px;
  border: 0;
  background: linear-gradient(
    90deg,
    rgba(219, 178, 146, 1) 0%,
    rgba(248, 223, 196, 1) 100%
  );
  box-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.5);
  border-radius: 43px;
  transform: translate(-50%, 0);
}

.modal .kqb-ybtn text {
  font-size: 36px;
  font-family: MicrosoftYaHei-Bold;
  color: rgba(120, 72, 47, 1);
}

.modal .kqb-ybtn text:first-child {
  font-weight: bold;
}

.fc-78482F {
  color: #78482f;
}

button.kqb-ybtn.fc-78482F {
  background-color: #78482f;
}

button.kqb-ybtn.fc-78482F span:first-child {
  font-size: 40px;
  font-weight: bold;
}

.loading {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 121;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}
.loading img {
  width: 4rem;
  height: 4rem;
  margin: 7.5rem auto;
}
</style>
